module.exports = __webpack_public_path__ + "static/onlineyoga-0a068e13a51c2cb72f341c311c3d4c1c.gif";